import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import t from '../../utils/translateUtil';
import { STEPS_REGISTER, verify_id_number } from '../../utils/util';
import RegisterView from './RegisterView';
import jwt_decode from "jwt-decode";
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import { clearOrderCache, getAddressHome, getContactInfo, getDeviceInfo, getOrderInfoCache, getPackageInfo, getPaymentInfo, getPaymentMethod, getUTMInfo, isVumaReachPackage, logOut, saveDataIntoAsyncStore, setAmountPayment, setContactInfo, setOrderInfoCache, setPaymentLinkInfo, setRegisterAttachments, setUTMInfo } from '../../utils/commons';
import CustomAlerts from '../../components/CustomAlerts';
import OrderProgress from '../orders/OrderProgress';
import { lab4services } from '../../services/wsclients/lab4services';
import ProcessFormView from './ProcessFormView';
import { httpUtil } from '../../services/wsclients/httpUtil';
import LinearBuffer from '../orders/LinearBuffer';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { connection } from '../../config';
import { makeStyles } from '@mui/styles';
import VerificationView from '../../components/VerificationView';
import { ErrorCodes } from '../../services/wsclients/resultUtil';
import CustomCircularProgress from '../../components/CustomCircularProgress';


//id number: 7707185170084
const useStyles = makeStyles((theme) => ({
    paperXs: {
        width: 500
    },
    paperSm: {
        width: 600
    },
    paperMd: {
        width: 900
    },
    paperLg: {
        width: 1000
    },
    paperXl: {
        width: 1200
    },
    title: {
        borderBottom: '1px solid ' + theme.palette.background.primary,
        paddingBottom: theme.spacing(1),
    },
    content: {
        marginTop: theme.spacing(1)
    }
}));

export default function RegisterControllerV2(props) {
    const history = useHistory();
    const classes = useStyles();
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [isSameHomeAddress, setSameHomeAddress] = useState(false);
    const [registerInfo, setRegisterInfo] = useState(getContactInfo() ? getContactInfo() : null);
    const [payment_selected, setPaymentSelected] = useState(null);
    const [options, setOptions] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selected, setSelected] = useState('1');
    const [validations, setValidations] = useState({
        email: undefined,
        password: undefined,
    });
    const [showLoadingEmail, onShowLoadingEmail] = useState(false);
    const [showButtonClose, setShowButtonClose] = useState(false);
    const [focusField, setFocus] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [error, setError] = useState({
        showAlert: false,
        close: true,
        message: '',
        status: '',
    });
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [showProgressOrder, setShowProgressOrder] = useState(false);
    const [fileIdNumber, setFileIdNumber] = useState(null);
    const [filePassport, setFilePassport] = useState(null);
    const [isAgreeTerm, setAgreeTerm] = useState(false);
    const [progressEasypay, setProgressEasypay] = useState(false);
    const { t } = useTranslation();
    const package_info = getPackageInfo() ? getPackageInfo() : null;
    const address = getAddressHome() ? getAddressHome() : null;
    const [alerts, setAlerts] = useState([]);
    const { palette } = useTheme();

    const [otp, setOtp] = useState('');
    const [openVerificationView, setOpenVerificationView] = useState(false);
    const [openContactExistsDialog, setOpenContactExistsDialog] = useState(false);
    const [tempEmail, setTempEmail] = useState('');
    const [idOtp, setIdOtp] = useState('');
    const [addressHome, setAddressHome] = useState({});
    const [loadingOtp, setLoadingOtp] = useState(false);
    const [step,setStep] = useState(props.tab ? props.tab : 0)
    console.log("package_info==", package_info);
    console.log("RegisterControllerV2 address==", address);

    const dates = [
        {
            label: '1',
            value: '1',
        },
        {
            label: '16',
            value: '16',
        },
        {
            label: '21',
            value: '21',
        },
        {
            label: '26',
            value: '26',
        },
    ]

    useEffect(() => {
        const optionsBill = [
            {
                label: 'Prepaid 28 days non-recurring',
                value: '1',
            },
            {
                label: 'Monthly Recurring',
                value: '2',
                child: renderChild(dates),
            },
        ]
    }, []);

    useEffect(() => {
        if (step === 1) {
            props.stepsControl.goToStepByName(STEPS_REGISTER.rica_verification)
        } 
        // else if (step === 2) {
        //     props.stepsControl.goToStepByName("Payment")
        // }
        else {

        }
    }, [step]);

    const onChangeOption = (e) => {
        setSelected(e.target.value);
    }

    const onChangeDate = (e) => {
        setSelectedDate(e.target.value);
    }

    const renderChild = (items) => {
        return (
            <div style={{ marginLeft: 20 }}>
                {items && items.length > 0 &&
                    <CustomRadioButtonGroup
                        items={items}
                        selected={selectedDate ? selectedDate : null}
                        onChange={onChangeDate}
                    />
                }
            </div>
        );
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
        setShowProgressOrder(false);
    }

    const onHandleUpload = (target, files) => {
        console.log("files upload ===", files);
    }

    const onSameHomeAddress = () => {
        setSameHomeAddress(!isSameHomeAddress);
    }

    const onChangePayment = (event) => {
        setPaymentSelected(event.target.value);
    }

    const onCheckEmail = async (email) => {
        try {
            onShowLoadingEmail(true);
            console.log("email===", email.target.value);
            let result = await wsclients.lab4services.onCheckEmailAddress(email.target.value);
            console.log("onCheckEmailAddress result===", result);
            onShowLoadingEmail(false);
            if (result.code === 'OK') {
                if (result.data.result === 'VALID') {
                    setValidations({
                        ...validations,
                        email: false,
                    });
                    return undefined;
                }
            }
            setValidations({
                ...validations,
                email: true,
            })
            return t('Please enter a valid e-mail address');
        }
        catch (ex) {
            console.log("onCheckEmailAddress exception===", ex);
        }
    }

    const onHandleBlur = (value, target) => {
        let validPhone = false;
        let validPassword = false;
        let validIdNumber = false;
        let validConfirmPassword = false;
        if (target === 'phone') {
            if (!value || isNaN(value)) validPhone = true;
            else if (value && value.length !== 10) {
                validPhone = true;
            } else {
                if (value) {
                    let startItem = value.substr(0, 1);
                    if (startItem !== '0') {
                        validPhone = true;
                    }
                }
            }
            setValidations(prevState => ({
                ...prevState,
                phone: validPhone,
            }));
            return validPhone;
        }
        if (target === 'password') {
            if (!value) {
                validPassword = true;
            } else if (value && value.length < 8) {
                validPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                password: validPassword,
            }));
            return validPassword;
        }
        if (target === 'id_number') {
            if (value && value.length !== 13) {
                validIdNumber = true;
            }
            else validIdNumber = verify_id_number(value) ? false : true;
            console.log("onvalidate id number ===", validIdNumber);
            setValidations(prevState => ({
                ...prevState,
                id_number: validIdNumber,
            }));
            return validIdNumber;
        }
        if (target === 'confirm_password') {
            if (!value) validConfirmPassword = true;
            else if (value && value.length < 8) {
                validConfirmPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                confirm_password: validConfirmPassword,
            }));
            return validConfirmPassword;
        }
        return false;
    }

    const onSubmit = async (values) => {
        console.log("form register values===", values);
       
        onShowLoading(true);
        try {
            const { first_name, last_name, email_address, mobile_number, password, confirm_password, id_number, passport_number,
                street_number, street_name, town_city, postal_code, state_province_county, apartment_name, apartment_number, referral_code } = values;
            if (id_number || passport_number) {
                let validEmail = onHandleBlur(email_address, 'email');
                let validPassword = onHandleBlur(password, 'password');
                let validIdNumber = passport_number ? false : onHandleBlur(id_number, 'id_number');
                let validConfirmPassword = onHandleBlur(confirm_password, 'confirm_password');
                let isCheckLocation = false;
                if (address && (address.tactical || address.pre_order_allowed)) {
                    isCheckLocation = true;
                } else  { 
                    isCheckLocation = await onCheckLocation(address.premise_ref_isp, address.openserve_ref_isp, address.metrofibre_ref_isp);
                }
                // isCheckLocation = true;
                if (!isCheckLocation) {
                    onShowMessage({
                        show: true,
                        content: t('address_used')
                    });
                    return false;
                }
                if (!validEmail && !validPassword && !validIdNumber && !validConfirmPassword) {
                    let contact_info = {
                        first_name: first_name,
                        last_name: last_name,
                        email: email_address,
                        password: password,
                        phone_number: mobile_number,
                        id_number: id_number,
                        passport_number: passport_number,
                        state_province_county: state_province_county,
                        referral_code: referral_code
                    }
                    let addressHome = {
                        street_number: street_number,
                        street_name: street_name,
                        town_city: town_city,
                        postal_code: postal_code,
                        apartment_name: apartment_name,
                        apartment_number: apartment_number,
                        state_province_county: state_province_county,
                        building: values.building ? values.building : null,
                        mdu_name: values.mdu_name ? values.mdu_name : null,
                        mdu_unitno: values.mdu_unitno ? values.mdu_unitno : null
                    }
                    setTempEmail(email_address);
                    setRegisterInfo(contact_info);
                    setAddressHome(addressHome)
                    setShowProgressOrder(true);
                    await onMakeOrderV2(contact_info, addressHome);
                    onShowLoading(false);
                    setShowButtonClose(true);
                }else { 
                    if(validIdNumber){
                        onShowMessage({ show: true, content: t('INVALID_ID') })
                    }
                }

            } else {
                onShowMessage({ show: true, content: t('MUST_INPUT_ID_OR_PASSPORT') })
            }
        }
        catch (error) {
            onShowLoading(false);
            console.log("register EXCEPPPPTIONNNN", error);
            onShowMessage({ show: true, content: t('EXCEPTION') })
        }
        onShowLoading(false);
    }

    const wait = m => new Promise(r => setTimeout(r, m))

    const onUploadFile = async (filesContact, token) => {
        let _filesUploaded = [];
        try {
            console.log("filesContact:", filesContact)
            for (let i = 0; i < filesContact.length; i++) {
                const file = filesContact[i];
                const result = await wsclients.config.uploadFilesNew({ file: file, token: token });
                if (result.code == 'OK') {
                    if (result.data.id) _filesUploaded.push(result.data.id);
                } else if (result.data && result.data.error == 'COM.CRM.EXCEPTIONS.INVALIDFILETYPEEXCEPTION') {
                    showAlert({ status: true, message: t('INVALID_FILE_TYPE') })
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddFilesContact = async (filesUploaded) => {
        try {
            for (let i = 0; i < filesUploaded.length; i++) {
                await wsclients.lab4services.onUploadFile(filesUploaded[i]);
            }
            await setAttachments([]);
        } catch (error) {
            console.log("onAddSRAttachment exception:", error);
        }
    }

    const showAlert = (status, message, close) => {
        onShowLoading(false);
        setMessage({
            showAlert: true,
            message: message,
            status: status,
            close: close
        });
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
            status: '',
            close: true
        });
    }

    const onAddImage = (target, files) => {
        console.log("AAAAAa onUploadFile ===");
        console.log("files onAddImage===", files);
        if (files && files.length > 0) {
            if (target === 'id_number') setFileIdNumber(files[0]);
            else if (target === 'passport_number') setFilePassport(files[0]);
            else setAttachments(files)
            setRegisterAttachments(files);
        }
    }

    const onMakeOrderV2 = async (contact_info, addressHome, contactInfo = false) => {
        try {
            console.log("contactInfo", contactInfo)
            console.log("AAAA address",address)
            let body = {
                product_id: package_info && package_info.id ? package_info.id : null,
                location_reference: address && address.metrofibre_ref_isp ? address.metrofibre_ref_isp : address && address.premise_ref_isp ? address.premise_ref_isp : address.premisesid,
                product_reference: package_info && package_info.sku ? package_info.sku : null,
                payment_redirect_url: window.location.origin + paths.orders_result,
                is_recuring: package_info && package_info.is_recuring ? package_info.is_recuring : false,
                recurring_payment_date: package_info && package_info.recurring_payment_date ? package_info.recurring_payment_date : null,
                product_type: package_info && package_info.product_type ? package_info.product_type : null,
                order_amount: package_info && package_info.price ? package_info.price : 0,
            }
            if (package_info && package_info.product_type === 'metrofibre') {
                // body.product_reference = package_info.code;
                body.product_reference = package_info?.product?.custom_fields?.find(x => x.key == 'metrofibre_tariff_id')?.value || package_info.code;
            }
            if (contactInfo && Object.keys(contactInfo).length > 0) {
                body.contact_id = contactInfo?.contact_id
                body.contact_code = contactInfo?.contact_code
            }
            let contact = {
                first_name: contact_info.first_name ? contact_info.first_name : null,
                last_name: contact_info.last_name ? contact_info.last_name : null,
                id_number: contact_info.id_number,
                passport_number: contact_info.passport_number,
                identification: {
                    username: contact_info.email ? contact_info.email : null,
                    password: contact_info.password ? contact_info.password : null,
                    validation_required: false,
                },
                phone_number: contact_info.phone_number,
                referral_code: contact_info.referral_code,
                country_code: 'ZAF',//hardcode,
                service_acceptance: true,
                email_opt_out: false,
                sms_opt_out: false,
                address: {
                    // address_type: 'HOME',
                    address_line_1: addressHome.street_number + ", " + addressHome.street_name,
                    address_line_2: address && address.suburb ? address.suburb : null,
                    state_province_county: addressHome.state_province_county ? addressHome.state_province_county : null,
                    town_city: addressHome.town_city,
                    postal_code: addressHome.postal_code,
                    lat: address && address.latitude ? address.latitude : null,
                    lon: address && address.longitude ? address.longitude : null,
                    apartment_name: addressHome.apartment_name ? addressHome.apartment_name : null,
                    apartment_number: addressHome.apartment_number ? addressHome.apartment_number : null,
                    vumatel_premise_id: address && address.premisesid ? address.premisesid : null,
                    network_type: address ? (address.network_type || address.networktype || null) : null,
                    building: addressHome.building ? addressHome.building : null,
                    mdu_name: addressHome.mdu_name ? addressHome.mdu_name : null,
                    mdu_unitno: addressHome.mdu_unitno ? addressHome.mdu_unitno : null,
                    uuid: address.premisesid ? address.premisesid : null,
                    metrofibre_ref_isp: address && address.metrofibre_ref_isp && package_info.product_type =="metrofibre" ? address.metrofibre_ref_isp : null,
                    metrofibre_polygon_id: address && address.metrofibre_polygon_id && package_info.product_type =="metrofibre" ? address.metrofibre_polygon_id : null
                }
            }
            if (package_info && package_info.reconnect) contact.reconnect = package_info.reconnect;
            if (package_info && package_info.ont) contact.ont = package_info.ont;
            if (package_info && package_info.line_uuid && package_info.line_uuid.uuid) contact.line_uuid = package_info.line_uuid.uuid;
            let deviceInfo = getDeviceInfo();
            if (package_info && package_info.product_type === 'vuma_core' && deviceInfo) {
                contact.device_name = deviceInfo.name ? deviceInfo.name : null;
            }
            else if (package_info && package_info.product_type === 'openserve') {
                if (deviceInfo) {
                    contact.device_name = deviceInfo.name ? deviceInfo.name : null;
                }
                body.openserve_location_reference = address && address.openserve_ref_isp ? address.openserve_ref_isp : null
                body.location_reference = address && address.openserve_ref_isp ? address.openserve_ref_isp : null
            }
            body.contact = contact;
            let utm_info = getUTMInfo();
            if (utm_info && utm_info.utm_source && utm_info.utm_campain) {
                body.utm_source = utm_info.utm_source;
                body.utm_campain = utm_info.utm_campain;
            }
            // debugger;
            console.log("AAAA body result: ", body);
            let isPreOrder = address && address.pre_order_allowed;
            if (isPreOrder) {
                await onMakePreOrder(body)
                return;
            }
            let result = await lab4services.registerContact(body);
            console.log("AAAA onMakeOrderV2 result: ", result);
            if (result.code == 'OK') {
                setUTMInfo(null)
                if (!contactInfo) {
                    if (result.data.access_token) {
                        httpUtil.startSession({
                            access_token: result.data.access_token,
                        })
                    }
                }
                if (!isVumaReachPackage(package_info.product_type)) {
                    let paymentMethodCache = getPaymentMethod();
                    setContactInfo({
                        id: result.data.contact_id,
                        email: contact_info.email,
                        code: result.data.contact_code,
                    });
                    if (paymentMethodCache == 'PAYGATE') {
                        setPaymentLinkInfo({
                            type: 'register',
                            ...result.data,
                        });
                        await initPayment();
                    }
                    else {
                        if (result.data && result.data.payment_easypay_url) {
                            setProgressEasypay(true)
                            window.open(result.data.payment_easypay_url, '_blank');
                            let isComplete = false;
                            for (let i = 0; i < 5; i++) {
                                if (isComplete) break;
                                await wait(5000);
                                isComplete = await getPaymentEasyPayInfo({ id: result.data.contact_id });
                            }
                            console.log("AAAA isComplete: ", isComplete)
                            if (isComplete) {
                                clearOrderCache();
                                await wait(2000);
                                history.push(paths.login)
                            } else {
                                onShowMessage({
                                    show: true,
                                    content: 'Please continue payment easypay.',
                                    action: () => {
                                        clearOrderCache();
                                        history.push(paths.login)
                                    }
                                });
                            }
                        }
                    }
                } else {
                    clearOrderCache();
                    await wait(2000);
                    window.location.href = result.data.vumatel_payment_url;
                }
            } else if (result.code == 'LOCATION_REFERENCE_IS_NOT_AVAILABLE') {
                onShowMessage({
                    show: true,
                    content: t('address_used')
                });
                return false;
            } else if (result.code === 'CREATE_CRM_ORDER_EXCEPTION') {
                onShowMessage({
                    show: true,
                    content: t('CREATE_CRM_ORDER_EXCEPTION')
                });
                return false;
            } else if (result.data && result.data.error && result.data.error.error == 'ORDER_FOR_CONTACT_IS_ALREADY_EXIST') {
                setOpenContactExistsDialog(true)
                setShowProgressOrder(false);
                return false;
            } else if (result.data && result.data.error && result.data.error.error == 'ID_NUMBER_OR_PASSPORT_ALREADY_EXIST') {
                // setOpenContactExistsDialog(true)
                // setShowProgressOrder(false);
                onShowMessage({
                    show: true,
                    content: t('ID_NUMBER_OR_PASSPORT_ALREADY_EXIST')
                });
                return false;
            }
            else if (result.data && result.data.error && result.data.error.error == 'CONTACT_ALREADY_SUBSCRIPTION') {
                onShowMessage({
                    show: true,
                    content: t('CONTACT_ALREADY_SUBSCRIPTION')
                });
                return false;
            }
            else {
                let entity = result.data && result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                let message = entity && entity.detail && typeof (entity.detail) === 'string' ? entity.detail : t('NETWORK_ISSUE');
                onShowMessage({
                    show: true,
                    content: message
                });
            }
        } catch (ex) {
            console.log("AAAA onMakeOrderv2 exception: ", ex);
            onShowMessage({
                show: true,
                content: t('CREATE_ORDER_FAILED')
            });
        }
    }

    const onMakePreOrder = async(body) => {
        console.log("AAAA onMakePreOrder body: ", body)
        try {
            let result = await lab4services.makePreorder(body);
            if (result.code == 'OK') {
                setUTMInfo(null);
                clearOrderCache();
                await wait(2000);
                history.push(paths.home)
            } else if (result.code == 'LOCATION_REFERENCE_IS_NOT_AVAILABLE') {
                onShowMessage({
                    show: true,
                    content: t('address_used')
                });
                return false;
            } else if (result.code === 'CREATE_CRM_ORDER_EXCEPTION') {
                onShowMessage({
                    show: true,
                    content: t('CREATE_CRM_ORDER_EXCEPTION')
                });
                return false;
            } else if (result.data && result.data.error && result.data.error.error == 'ORDER_FOR_CONTACT_IS_ALREADY_EXIST') {
                setOpenContactExistsDialog(true)
                setShowProgressOrder(false);
                return false;
            } else if (result.data && result.data.error && result.data.error.error == 'ID_NUMBER_OR_PASSPORT_ALREADY_EXIST') {
                // setOpenContactExistsDialog(true)
                // setShowProgressOrder(false);
                onShowMessage({
                    show: true,
                    content: t('ID_NUMBER_OR_PASSPORT_ALREADY_EXIST')
                });
                return false;
            }
            else if (result.data && result.data.error && result.data.error.error == 'CONTACT_ALREADY_SUBSCRIPTION') {
                onShowMessage({
                    show: true,
                    content: t('CONTACT_ALREADY_SUBSCRIPTION')
                });
                return false;
            }
            else {
                let entity = result.data && result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                let message = entity && entity.detail && typeof (entity.detail) === 'string' ? entity.detail : t('NETWORK_ISSUE');
                onShowMessage({
                    show: true,
                    content: message
                });
            }
        } catch (error) {
            console.log("AAAA onMakePreOrder error: ", error)
        }
    }

    const getPaymentEasyPayInfo = async (contact) => {
        let isComplete = false;
        try {
            let result = await lab4services.getOrderStatusV2({
                contact_id: contact.id,
                order_type: package_info.product_type,
            });
            if (result.code == 'OK' && result.data && result.data.status) {
                isComplete = result.data.status == 'COMPLETE' ? true : false;
            }
        } catch (error) {
            console.log("AAAA getPaymentEasyPayInfo error: ", error)
        }
        return isComplete;
    }

    const initPayment = async (isLoading) => {
        try {
            onShowLoading(isLoading)
            let contact_info = getContactInfo();
            let amount = package_info && package_info.price ? package_info.price : null;
            setAmountPayment(amount);
            let body = {
                contact_id: contact_info && contact_info.id ? contact_info.id : null,
                email_address: contact_info && contact_info.email ? contact_info.email : null,
                contact_code: contact_info && contact_info.code ? contact_info.code : null,
                amount: amount,
                type: package_info && package_info.store_card ? package_info.store_card : null
            };
            let result;
            if (connection.newApiFlow) result = await lab4services.initTopup(body);
            else result = await lab4services.initPayment(body);
            console.log("result initPayment ===", result);
            if (result.code === 'OK') {
                let urlFormPaygate = document._portalConfig.urlFormPaygate;
                if (result && result.code === 'OK' && result.data && result.data.client_token) {
                    let clientToken = result.data.client_token;
                    var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                    console.log('splitToken:', splitToken);
                    if (splitToken.length > 0) {
                        var payRequestIDRes = splitToken[0];
                        var checkSumRes = splitToken[1];
                        var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                            + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                            + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                            + '</form>'
                        console.log('htmlContent:', htmlContent);
                        setHtmlContent(htmlContent);
                        setOpenProcessForm(true);
                        setShowProgressOrder(false);
                    }
                } else if (result.data && result.data.state === 'REJECTED') {
                    onShowMessage({
                        show: true,
                        message: t('INIT_PAYMENT_REJECTED'),
                        isConfirm: true,
                        confirmAction: {
                            okAction: async () => await initPayment(true),
                            okTitle: t('btn_try'),
                            cancelTitle: t('btn_close'),
                            cancelAction: () => history.push(paths.home),
                        },
                    })
                }
            } else {
                onShowMessage({
                    show: true,
                    message: t('INIT_PAYMENT_FAILED'),
                    isConfirm: true,
                    confirmAction: {
                        okAction: async () => await initPayment(true),
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                        cancelAction: () => history.push(paths.home),
                    },
                });
                return false;
            }
        } catch (ex) {
            console.log("initPayment exception ===", ex);
        }
        onShowLoading(false)
    }

    const onCheckLocation = async (location_id, openserve_ref_isp, metrofibre_ref_isp) => {
        let isAllowLocation = false;
        try {
            let queryParams = {
                locationId: location_id,
                openserve_ref_isp: openserve_ref_isp,
                metrofibre_ref_isp: metrofibre_ref_isp,
            }
            if (package_info && package_info.product_type == 'octotel') {
                queryParams = {
                    uuid: address.premisesid,
                    lat: address.latitude,
                    lng: address.longitude,
                }
            }
            let result = await lab4services.checkLocationAvaibleOrderV3(queryParams);
            console.log("AAAA onCheckLocation result: ", result);
            if (result.code == 'OK') {
                let product_type = package_info && package_info.product_type ? package_info.product_type : null;
                if (product_type == 'openserve') {
                    if (result.data && result.data.is_availabe_create_openserve_order) {
                        isAllowLocation = onCheckProductsOpenserve(result.data.openserve_services);
                    } else if (result.data && !result.data.is_available_create_order) {
                        onShowMessage({
                            show: true,
                            content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                        });
                        isAllowLocation = false;
                    }
                } else if (product_type == 'octotel') {
                    if (result.data && result.data.octotel_services && result.data.octotel_services.length > 0) {
                        for (let i = 0; i < result.data.octotel_services.length; i++) {
                            const element = result.data.octotel_services[i];
                            if (package_info.code.includes(element.productCode)) {
                                isAllowLocation = true;
                                break;
                            }
                        }
                    } else {
                        onShowMessage({
                            show: true,
                            content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                        });
                        isAllowLocation = false;
                    }
                } else if (product_type == 'metrofibre') {
                    if (result.data && result.data.is_available_create_order_metrofibre) {
                        isAllowLocation = true;
                    } else {
                        isAllowLocation = false;
                    }
                }
                else {
                    if (result.data && result.data.is_available_create_order) {
                        isAllowLocation = true;
                    } else {
                        onShowMessage({
                            show: true,
                            content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                        });
                        isAllowLocation = false;
                    }
                }
            }
        } catch (ex) {
            console.log("AAAA onCheckLocation exception: ", ex);
        }
        return isAllowLocation;
    }

    const onCheckProductsOpenserve = (openserveServices) => {
        let isCheck = false;
        try {
            if (openserveServices && openserveServices.length > 0 && package_info && package_info.sku) {
                for (let i = 0; i < openserveServices.length; i++) {
                    const item = openserveServices[i];
                    if (package_info.sku.includes(item.ProductCode + '-')) {
                        isCheck = true;
                        break;
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onCheckProductsOpenserve error: ", error);
        }
        console.log("AAAA onCheckProductsOpenserve isCheck: ", isCheck)
        return isCheck;
    }

    const onConfirmProcess = async (values) => {
        if(step == 0){
            setStep(1)
            
            return
        }
        console.log("AAAA values: ", values)
        if (!validations.email) {
            if (package_info && !isVumaReachPackage(package_info.product_type)) {
                onShowMessage({
                    show: true,
                    content: t('agree_term_message'),
                    isConfirm: true,
                    confirmAction: {
                        okAction: async () => {
                            onShowMessage({});
                            await onSubmit(values)
                        },
                        okTitle: t('Agree'),
                        cancelAction: () => onShowMessage({}),
                    },
                    title: t('Information Consent')
                })
            } else {
                await onSubmit(values);
            }
        } else {
            onShowMessage({ show: true, content: t('invalid_email_format') })
        }
    }



    const handleVerifyOtp = async () => {
        setLoadingOtp(true)
        try {
            onShowLoading(true);
            let result = await wsclients.contacts.authenticate({
                "provider": "EMAIL",
                "username": tempEmail,
                "application_id": document._portalConfig.applicationID
            }, true);
            console.log("Authenticate result:", result);
            if (result.code === ErrorCodes.OK) {
                setIdOtp(result.data.auth_otp);
                setOpenContactExistsDialog(false);
                setOpenVerificationView(true);
            } else {
                let errorMessage;
                switch (result.code) {
                    case ErrorCodes.INVALID_LOGIN:
                        errorMessage = t('INVALID_LOGIN');
                        break;
                    case ErrorCodes.EMAIL_NOT_VERIFIED:
                        errorMessage = t('EMAIL_NOT_VERIFIED');
                        break;
                    case ErrorCodes.TOO_MANY_REQUESTS:
                        errorMessage = t('TOO_MANY_REQUESTS');
                        break;
                    default:
                        errorMessage = t('UNCLASSIFIED_ERROR');
                }
                onShowMessage({
                    show: true,
                    content: errorMessage,
                    isConfirm: false,
                    showButtonClose: true,
                    onClose: () => onShowMessage({})
                });
            }
        } catch (error) {
            console.log("Authenticate exception:", error);
            onShowMessage({
                show: true,
                content: t('UNKNOWN'),
                isConfirm: false,
                showButtonClose: true,
                onClose: () => onShowMessage({})
            });
        } finally {
            onShowLoading(false);
            setLoadingOtp(false)
        }

    };


    const handleCancelDialog = () => {
        setOpenContactExistsDialog(false);
    };


    const handleOtpSubmit = async () => {
        try {
            onShowLoading(true);

            let result = await wsclients.contacts.verifyOtp({ auth_otp: idOtp, code: otp });
            if (result.code === 'OK') {
                if (result.data.access_token) {
                    httpUtil.startSession({
                        access_token: result.data.access_token,
                    })
                }

                let resultContact = await wsclients.contacts.getContact()
                if (resultContact.code == "OK") {
                    setOpenProcessForm(true)
                    setOpenVerificationView(false);
                    await onMakeOrderV2(registerInfo, addressHome, { contact_id: resultContact?.data?.id, contact_code: resultContact?.data?.code });
                }
            } else {
                onShowMessage({ show: true, content: t('INVALID_OTP') });
            }

        } catch (error) {
            console.log("OTP verification error:", error);
            onShowMessage({ show: true, content: t('EXCEPTION') });
        } finally {
            onShowLoading(false);
        }
    };
    return (
        <div>
            <RegisterView
                isSameHomeAddress={isSameHomeAddress}
                payment_selected={payment_selected}
                options={options}
                selected={selected}
                address={address}
                validations={validations}
                showLoadingEmail={showLoadingEmail}
                focusField={focusField}
                registerInfo={registerInfo}
                isAgreeTerm={isAgreeTerm}
                stepsControl={props.stepsControl}
                // showProgressOrder={showProgressOrder}
                onSameHomeAddress={onSameHomeAddress}
                onHandleUpload={onHandleUpload}
                onChangePayment={onChangePayment}
                onSubmit={onConfirmProcess}
                onChangeOption={onChangeOption}
                onCheckEmail={onCheckEmail}
                onHandleBlur={onHandleBlur}
                onAddImage={onAddImage}
                setAgreeTerm={setAgreeTerm}
                setStep={setStep}
                step={step}
            />
            {alerts && alerts.length > 0 && <CustomAlerts alerts={alerts} />}
            {message.show && <CustomAlert
                open={message.show}
                message={message.content ? message.content : (message.message ? message.message : 'Unknown error!')}
                showButtonClose={true}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                onClose={message.action ? message.action : () => onShowMessage({})}
                okTitle={message.okTitle}
                cancelTitle={message.cancelTitle}
                title={message.title}
                color={palette.primary.main}

            />}
            {showLoading && <CustomLoading open={showLoading} />}
            {openProcessForm && <ProcessFormView
                open={openProcessForm}
                onClose={() => setOpenProcessForm(false)}
                html_content={htmlContent}
            />}
            {showProgressOrder && <CustomAlert
                open={showProgressOrder}
                title={t('progress_order')}
                maxWidth='sm'
                title_close={t('btn_close')}
                customMessage={<>
                    <Grid item xs={12}>
                        <LinearBuffer status={'IN_PROGRESS'} />
                        <Typography>{t('warning_progress_order')}</Typography>
                    </Grid>
                </>}
            />}

            <Dialog
                open={openContactExistsDialog}
                onClose={() => { setOpenContactExistsDialog(false) }}
                maxWidth={'sm'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{
                    paper: classes.paperSm,
                }}
            >
                <DialogTitle id="alert-dialog-title" className={classes.title}>
                    {t('CONTACT_ALREADY_EXIST')}
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <Typography>{t('PLEASE_VERIFY_OTP')}</Typography>
                    <TextField
                        fullWidth
                        value={tempEmail}
                        onChange={(e) => setTempEmail(e.target.value)}
                        margin="normal"
                        variant="outlined"
                        disabled
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDialog} color="primary">
                        {t('btn_cancel')}
                    </Button>
                    <Button onClick={handleVerifyOtp} color="primary" variant="contained">
                        {loadingOtp ? <CustomCircularProgress /> : <>{t('VERIFY_OTP')}</>}
                    </Button>
                </DialogActions>
            </Dialog>
            {!showLoading && <VerificationView
                otp={otp}
                setOtp={setOtp}
                onSubmit={handleOtpSubmit}
                isOpen={openVerificationView}
                onClose={() => setOpenVerificationView(false)}
                title={t('VERIFY_OTP')}
                obfuscated_value={tempEmail ? tempEmail.replace(/(.{2}).*?(@.*)/, '$1****$2') : ''}
                showProcessing={showLoading}
                message={message.content}
            />}
        </div>
    );
}